import Typography from '@mui/material/Typography'
import { useContext } from 'react'
import Schedule from 'assets/icons/event/schedule.svg'
import { LocaleContext } from 'components/common/LocaleContext'
import {
  getHoursForTimezone,
  getMinutesForTimezone,
  getTimeForTimezone
} from 'components/common/date.utils'
import { unifiedColors } from 'styles/colors'
import { RaceDetail } from './RaceCard.style'

interface RaceCardTimeProps {
  startDate: Date
  timeZone: string | null
}

const RaceCardTime = ({ startDate: date, timeZone }: RaceCardTimeProps) => {
  const { dateStringLocale } = useContext(LocaleContext)
  const startTime = getTimeForTimezone(date, timeZone, dateStringLocale)
  const hours = getHoursForTimezone(date, timeZone)
  const minutes = getMinutesForTimezone(date, timeZone)

  if (hours === 0 && minutes === 0) {
    return null
  }

  return (
    <RaceDetail>
      <Schedule />
      <Typography variant="body1" color={unifiedColors.label.subdued}>
        {startTime}
      </Typography>
    </RaceDetail>
  )
}

export default RaceCardTime
